import { createApp } from 'vue';

import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import { getGlobalChartOptions } from 'JIX/highcharts/configs/generic_chart.js';
import JobsearchResultApp from 'JIX/components/jobsearch/JobsearchResultApp.vue';
import createStore from 'JIX/store/jobsearch.js';

Highcharts.setOptions(getGlobalChartOptions());
const stash = window.Stash['jobsearch/result_app'];

const store = createStore({ ...stash.storeData });

const app = createApp(JobsearchResultApp, stash.rootProps);
app.use(store);
app.use(HighchartsVue, { tagName: 'Highcharts' });
app.mount(stash.mountSelector);
